import React, { useEffect } from "react";
import { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import Nav from "../../../theme_1/Nav";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useLocation } from "react-router-dom";
import { axiosInstance } from "../../../../config/axiosConfig";
import { useSelector } from "react-redux";
import useLoader from "../../../modals/hooks/useLoader";
import RecommendedForYou from "../../../containers/commonComponent/RecommendedForYou";
import RightSideBar from "../../../containers/commonComponent/rightSideBar";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../common/toastMeassage/ToastMeassage";
import JobsHeader from "../../../theme_1/staffSignUp/JobsHeader";
import MyJobDetails from "./MyJobDetails";
import Modal from "../../../common/modal";

const staffMyJobDetails = ({ pageIdentity }) => {
  const history = useHistory();
  const token = localStorage.getItem("accessToken");
  const location = useLocation();
  const { prevPath } = location.state || {};
  const [jobData, setJobData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showLoader, hideLoader } = useLoader();
  const [profileCompleted, setProfileCompleted] = useState(true);
  const [showIncompleteModal, setShowIncompleteModal] = useState(false);
  const [incompleteFields, setIncompleteFields] = useState({});
  const fieldLabels = {
    FunctionalArea: "Functional Area",
    Specialization: "Specialization",
    currentLocation: "Current Location",
    currentProfessionalStatus: "Current Professional Status",
    resume: "Resume",
  };
  const profile = useSelector((state) => state.data.profile);

  const applyJob = async ({ jobCardData }) => {
    if (!profileCompleted) {
      setShowIncompleteModal(true);
      return;
    }
    const id = jobCardData?.data?._id;
    try {
      setLoading(true);
      let url = `/v1/LHS/job/apply/${id}`;
      const datas = await axiosInstance.post(url, { costPerHour: "50" });
      if (
        datas.Message ==
        "Positions Have been Filled. Cannot Apply for this Job.."
      ) {
        showSuccessToast(datas.Message);
      }
      showSuccessToast("Applied successfully!");
      getJobsById(location?.pathname.split("/")[2]);
    } catch (error) {
      showErrorToast(error.Message);
    } finally {
      setLoading(false);
    }
  };

  const getJobsById = async (hospitalId) => {
    try {
      showLoader();
      const url = `/v2/LHS/User/getJobById/${hospitalId}`;
      const response = await axiosInstance.get(url);
      if (response.data.data) {
        setJobData(response.data.data.data?.[0]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      hideLoader();
    }
  };
  useEffect(() => {
    const checkProfileCompletion = async () => {
      try {
        const res = await axiosInstance.get(
          `v1/LHS/staff/checkUserProfileCompletion`
        );
        const fields = res?.data?.fields;
        setIncompleteFields(fields || {});
        const isComplete = Object.values(fields || {}).every(Boolean);
        setProfileCompleted(isComplete);
      } catch (err) {
        console.error("Error checking profile completion:", err);
      }
    };

    checkProfileCompletion();

    if (location?.pathname.split("/")[2]) {
      getJobsById(location?.pathname.split("/")[2]);
    }
  }, [location?.pathname.split("/")[2]]);

  useEffect(() => {
    if (location?.pathname.split("/")[2]) {
      getJobsById(location?.pathname.split("/")[2]);
    }
  }, [location?.pathname.split("/")[2]]);

  return (
    <>
      {token ? <Nav /> : <JobsHeader />}
      <div
        className="flex justify-center"
        style={{ backgroundColor: "#F3F2EF", minHeight: "calc(100vh - 60px)" }}
      >
        <div className="lg:flex gap-3 block justify-between align-top py-4 w-11/12 mx-auto max-w-[1500px]">
          <RightSideBar className="sticky h-auto min-w-[25%] hidden lg:block" />
          <MyJobDetails
            closeJobDetails={() =>
              history.push(token ? prevPath || "/myJob" : prevPath || "/jobs")
            }
            detailsData={{
              data: jobData,
              pageType:
                !jobData?.positionsAvailable && token && profile
                  ? "filled"
                  : jobData?.isApplied
                  ? "applied"
                  : "apply",
            }}
            loading={loading}
            buttonAction={applyJob}
          />
          <RecommendedForYou />
        </div>
      </div>
      <Modal
        isOpen={showIncompleteModal}
        onClose={() => setShowIncompleteModal(false)}
        className=" md:w-1/2 xl:w-1/3 md:mt-0 !rounded-sm"
      >
        <div className="flex flex-col gap-5 items-center justify-center  bg-white rounded-[15px]">
          <p className="font-semibold text-xl">
            To apply for this job, complete your profile.
          </p>
          <div className="w-full text-left">
            <p className="font-medium text-gray-700 mb-1">Incomplete fields:</p>
            <ul className="list-disc list-inside text-sm text-red-600">
              {Object.entries(incompleteFields)
                .filter(([_, value]) => value === false)
                .map(([key]) => (
                  <li key={key}>{fieldLabels[key] || key}</li>
                ))}
            </ul>
          </div>
          <div className="flex w-full gap-4 max-w-[271px] mt-4">
            <button
              className="w-full rounded-[28px] p-2 h-[44px] border"
              onClick={() => setShowIncompleteModal(false)}
            >
              Cancel
            </button>
            <button
              className="w-full bg-[#73C7A9] text-white rounded-[28px] p-2 h-[44px]"
              onClick={() => {
                setShowIncompleteModal(false);
                history.push("/main/staff/profile");
              }}
            >
              Go to Profile
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default staffMyJobDetails;
